/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_LaundryInputs */

const cs_enum_laundry = /** @type {(inputs: Enum_LaundryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prádelna`)
};

const en_enum_laundry = /** @type {(inputs: Enum_LaundryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laundry`)
};

/**
* | output |
* | --- |
* | "Laundry" |
*
* @param {Enum_LaundryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_laundry = /** @type {((inputs?: Enum_LaundryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_LaundryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_laundry(inputs)
	return cs_enum_laundry(inputs)
});